import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { DataTablesModule } from 'angular-datatables';

import { ModalNewAssetComponent } from './modal-new-asset/modal-new-asset.component';
import { ModalAddAssetComponent } from './modal-add-asset/modal-add-asset.component';
import { ModalNewLocationComponent } from './modal-new-location/modal-new-location.component';
import { ModalNewOrganisationComponent } from './modal-new-organisation/modal-new-organisation.component';
import { ModalNewAssetPresetComponent } from './modal-new-asset-preset/modal-new-asset-preset.component';
import { ModalNewUserComponent } from './modal-new-user/modal-new-user.component';
import { ModalAssignableAssetComponent } from './modal-assignable-asset/modal-assignable-asset.component';
import { ModalJobAssetDetailsComponent } from './modal-asset-details-job/modal-job-asset-details.component';
import { ModalSignatureComponent } from './modal-signature/modal-signature.component';
import { ModalFileUploadComponent } from './modal-file-upload/modal-file-upload.component';
import { ModalImageUploadComponent } from './modal-image-upload/modal-image-upload.component';
import { ModalNewConditionReportComponent } from './modal-new-condition/modal-new-condition.component';
import { ModalCreateHeicJobComponent } from './modal-create-heic-job/modal-create-heic-job.component';
import { ModalObservationComponent } from './modal-observation/modal-observation.component';
import { ModalAddAssetConditionComponent } from './modal-add-asset-condition/modal-add-asset-condition.component';
import { FileUploadModule, FileSelectDirective, FileDropDirective } from 'ng2-file-upload';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ModalDatePickerComponent } from './modal-datepicker/modal-datepicker.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { ModalAddLogComponent } from './modal-add-log/modal-add-log.component';
import { ModalFilterSelectComponent } from './modal-filter-select/modal-filter-select.component';
import { ModalAssetDetailsComponent } from './modal-asset-details/modal-asset-details.component';
import { ModalRiskFormComponent } from './modal-risk-form/modal-risk-form.component';
import { ModalNewReportComponent } from './modal-new-report/modal-new-report.component';
import { ModalViewReportComponent } from './modal-view-report/modal-view-report.component';
import { ModalReportWhereComponent } from './modal-report-where/modal-report-where.component';
import { ModalPowerAlertComponent } from './modal-power-alert/modal-power-alert.component';
import { ModalCustomRemedialComponent } from './modal-custom-remedial/modal-custom-remedial.component';
import { ModalStockOrderComponent } from './modal-stock-order/modal-stock-order.component';
import { ModalSelectRemedialsComponent } from './modal-select-remedials/modal-select-remedials.component';
import { ModalCertPreviewComponent } from './modal-cert-preview/modal-cert-preview.component';
import { ModalCondmenAssetCertComponent } from './modal-condmen-asset-cert/modal-condmen-asset-cert.component';
import { NavBarMenuComponent } from './navbar-menu/navbar-menu.component';
import { ModalSingleObservationComponent } from './modal-single-observation/modal-single-observation.component';
import { ModalViewImageComponent } from './modal-view-image/modal-view-image.component';
import { ModalVehicleReportComponent } from './modal-vehicle-report/modal-vehicle-report.component';
import { ModalQuoteComponent } from './modal-quote/modal-quote.component';


@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        AngularSignaturePadModule,
        FileUploadModule,
        ImageCropperModule,
        FlatpickrModule,
        DataTablesModule
    ],
    declarations: [
        ModalNewAssetComponent,
        ModalAddAssetComponent,
        ModalNewAssetPresetComponent,
        ModalNewLocationComponent,
        ModalNewUserComponent,
        ModalNewOrganisationComponent,
        ModalAssignableAssetComponent,
        ModalJobAssetDetailsComponent,
        ModalAssetDetailsComponent,
        ModalSignatureComponent,
        ModalFileUploadComponent,
        ModalNewConditionReportComponent,
        ModalImageUploadComponent,
        ModalCreateHeicJobComponent,
        ModalAddAssetConditionComponent,
        ModalObservationComponent,
        ModalDatePickerComponent,
        ModalAddLogComponent,
        ModalFilterSelectComponent,
        ModalRiskFormComponent,
        ModalNewReportComponent,
        ModalViewReportComponent,
        ModalReportWhereComponent,
        ModalPowerAlertComponent,
        ModalCustomRemedialComponent,
        ModalStockOrderComponent,
        ModalSelectRemedialsComponent,
        ModalCertPreviewComponent,
        ModalCondmenAssetCertComponent,
        NavBarMenuComponent,
        ModalSingleObservationComponent,
        ModalViewImageComponent,
        ModalVehicleReportComponent,
        ModalQuoteComponent
    ],
    exports: [
        ModalNewAssetComponent,
        ModalAddAssetComponent,
        ModalNewAssetPresetComponent,
        ModalNewLocationComponent,
        ModalNewUserComponent,
        ModalNewOrganisationComponent,
        ModalAssignableAssetComponent,
        ModalJobAssetDetailsComponent,
        ModalAssetDetailsComponent,
        ModalSignatureComponent,
        ModalFileUploadComponent,
        ModalNewConditionReportComponent,
        ModalImageUploadComponent,
        ModalCreateHeicJobComponent,
        ModalAddAssetConditionComponent,
        ModalObservationComponent,
        ModalDatePickerComponent,
        ModalAddLogComponent,
        ModalFilterSelectComponent,
        ModalRiskFormComponent,
        ModalNewReportComponent,
        ModalViewReportComponent,
        ModalReportWhereComponent,
        ModalPowerAlertComponent,
        ModalCustomRemedialComponent,
        ModalStockOrderComponent,
        ModalSelectRemedialsComponent,
        ModalCertPreviewComponent,
        ModalCondmenAssetCertComponent,
        NavBarMenuComponent,
        ModalSingleObservationComponent,
        ModalViewImageComponent,
        ModalVehicleReportComponent,
        ModalQuoteComponent
    ],
})
export class ComponentsModule { }
